import toast from 'react-hot-toast';

// Few refs that benefit from explicit client wording beyond the backend message.
const REF_TR: Record<string, string> = {
  A071: 'Tarih aralığı çakışıyor',
  A072: 'Bu vardiya aktif bir atamada kullanıldığı için silinemez.',
};

// Hardened: this function can ONLY return a value out of a `typeof … === 'string'` branch (or the
// literal fallback), so an object body can never reach the output → "[object Object]" and raw HTML
// (nginx 502/504 markup) are structurally impossible. Handles every response-body shape the backend
// can emit: JSON ErrorResponse ({ message }), a legacy bare String, HTML, null, and network errors.
export function getApiErrorMessage(error: any, fallback = 'Bir hata oluştu. Lütfen tekrar deneyin.'): string {
  const data = error?.response?.data;

  // 1) Standard ErrorResponse JSON — trust `.message` only when it is a non-empty string.
  if (data && typeof data === 'object' && typeof data.message === 'string' && data.message.trim()) {
    return data.message;
  }
  const ref = data && typeof data === 'object' ? data.errorRef : undefined;
  if (ref && REF_TR[ref]) return REF_TR[ref];

  // 2) Legacy bare-string backend body — but reject HTML (nginx 502/504) so we never dump markup.
  if (typeof data === 'string' && data.trim() && !/^\s*</.test(data)) return data.trim();

  // 3) Network / no-response (data null/undefined) or the noisy axios "Request failed with status
  //    code …" string → fall back to a clean message.
  return error?.message && !/status code/i.test(error.message) ? error.message : fallback;
}

export function toastApiError(error: any, fallback?: string) {
  toast.error(getApiErrorMessage(error, fallback));
}
